<!-- Mark of a format (data.series): its icon in its colour, otherwise a coloured dot. Same markup as the legacy
     seriesMark() (series.js); sizes: dot (no icon), cls (FontAwesome icon), img (user image). -->
<script setup lang="ts">
import { computed } from 'vue'
import LookIcon from './LookIcon.vue'
import { cleanLook } from '../features/looks'
import { safeColor } from '../utils/color'

const props = withDefaults(defineProps<{ format: { color: string; icon?: string }; dot?: string; cls?: string; img?: string }>(),
  { dot: 'w-2.5 h-2.5', cls: 'text-[11px]', img: 'w-3.5 h-3.5' })
const look = computed(() => (props.format.icon ? cleanLook({ icon: props.format.icon, color: safeColor(props.format.color) }) : null))
</script>

<template>
  <LookIcon v-if="look && look.icon" :look="look" :cls="cls" :img="img" />
  <span v-else :class="[dot, 'rounded-full inline-block flex-shrink-0']" :style="{ background: safeColor(format.color) }"></span>
</template>
